/** 正则表达式*/
export const Patterns = {
    pattern_telephone: /^.{0,20}$/,
    names: /^.{0,20}$/,
    /** 手机号正则*/
    pattern_mobile: /^[1][0-9]{10}$/,
    /** 姓名正则，（大小写字母，汉字，2-30位）*/
    pattern_name: /^([a-zA-Z\u4e00-\u9fa5\·]{2,30})$/,
    /** 详细地址，任意字符5-50个*/
    pattern_address: /^.{5,50}$/,
    /** 邮政编码，6位纯数字*/
    pattern_zipCode: /^([0-9]{6})$/,
    /*不包含中文*/
    pattern_noHanzi: /^[^\u4e00-\u9fa5]+$/,
    /** 登录新密码,长度6-20，大小写字母、数字、英文符号 字母、数字同时存在*/
    pattern_newPassword: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![a-zA-z~!_@#$%^&*,.\-`;<>?:’”]+$)(?![0-9~!_@#$%^&*,.\-`;<>?:’”]+$)[a-zA-Z\d~!_@#$%^&*,.\-`;<>?:’”]{6,20}$/,
    /** 登录密码,长度6-20，大小写字母、数字、英文符号（~!@#$%^&*,.;:’”?\/）*/
    pattern_password: /^[a-zA-Z0-9~!_@#$%^&*,.;:’”?\/]{6,20}$/,
    /** 用户名，0-50字符长度限制，支持大小写英文字母、数字及符号，不能输入汉字*/
    pattern_username: /^[a-zA-Z0-9~!_@#$%^&*,.\-`;<>?:’”]{0,50}$/,
    /** 备注，任意字符0-100位*/
    pattern_remark: /^.{0,100}$/,
    /** 银行开户名称，2-20位汉字、大小写字母*/
    pattern_accountName: /^([a-zA-Z\u4e00-\u9fa5\·]{2,20})$/,
    /** 开户支行，5-30位任意字符*/
    pattern_branchBank: /^.{5,30}$/,
    /** 银行卡号，纯数字，长度16-19*/
    pattern_accountNumber: /^[0-9]{16,19}$/,
    /** 身份证*/
    pattern_cid: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/,
    /** 驾照（驾驶证）*/
    pattern_drive: /^.{7,20}$/,
    /** 护照*/
    pattern_passport: /^.{7,20}$/,
    /** 港台同胞证*/
    pattern_HKM: /^.{7,20}$/,
    /** 考勤项目新增，任意字符2-20个*/
    pattern_attendaceAdd: /^.{2,20}$/,
    /** 机构级别自定义1-20个*/
    pattern_companyLevel: /^.{1,20}$/,
    /** 公司名称/产品名称/证件号，任意字符2-50个*/
    pattern_insuranceCompany: /^.{2,50}$/,
    /** 保单号，2-100字符长度限制，支持大小写英文字母、数字及符号，不能输入汉字*/
    pattern_policyNumber: /^.{1,50}$/,
    /** 只能输入数字并保留小数点后两位*/
    pattern_decimalPoint: /^\d{0,8}\.{0,1}(\d{1,2})?$/,
    /** 已缴费次数，纯数字，长度1-999*/
    pattern_paymentTimes: /^(?!0)\d{1,3}$/,
    /** 详情密码,长度5-20，大小写字母、数字、英文符号（~!@#$%^&*,.;:’”?\/）*/
    pattern_detailPassword: /^[a-zA-Z0-9~!_@#$%^&*,.;:’”?\/]{5,20}$/,
    /** 手机验证码 6位纯数字*/
    pattern_smsCode: /^\d{6}$/,
    /** 业务员编号 姓名 任意字符0-30个*/
    pattern_SalesmanCoding: /^.{0,30}$/,
    /** 业务员姓名 姓名 0-30字符长度限制，支持大小写英文字母、数字、汉字及·*/
    pattern_salesMan: /^[0-9A-Za-z·\u4e00-\u9fa5]{0,30}$/,
    /** 业务员编码 姓名 0-30字符长度限制*/
    pattern_salesManCode: /^.{0,30}$/,
    // pattern_salesManCode:/^[0-9a-zA-Z]{0,30}$/, ///** 业务员编码 姓名 0-30字符长度限制，支持大小写英文字母+数字，*/
    /** 电子邮箱 0-50位长度限制，支持英文大小写字母、数字、英文符号，*/
    pattern_emile: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    /** 地址及备注，任意字符0-200位*/
    pattern_addressRemark: /^[\S\s\n.]{0,200}$/,
    /** 合同号，任意字符0-50位*/
    pattern_contractNumber: /^.{0,50}$/,
    /** 执业证号，任意字符0-50位,仅支持大小写字母、数字、英文符号*/
    pattern_licenseNumber: /^[a-zA-Z0-9~!_@#$%^&*,.;:’”?\/]{0,50}$/,
    /*展业端配置 产品价格 最大10万，*/
    // pattern_shopProdPrice:/^\d{0,5}$/,
    pattern_shopProdPrice: /^\d{0,4}\.{0,1}(\d{1,2})?$/,////最多两位小数
    /*链接地址*/
    pattern_productURL: /^(http|https)\:\/\/\S*$/,
};
